import { CommandProps, mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { ReactReportComponentEmbed } from './component';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        reportComponentEmbed: {
            setReportComponentEmbed: (reportComponentId: string) => ReturnType;
        };
    }
}

export const ReportComponentEmbed = Node.create({
    name: 'reportComponentEmbed',
    group: 'block',
    atom: true,
    draggable: true,
    selectable: true,

    addAttributes() {
        return {
            reportComponentId: {
                default: null,
                parseHTML: (element) => element.getAttribute('data-report-component-id'),
                renderHTML: (attributes) => ({
                    'data-report-component-id': attributes.reportComponentId,
                }),
            },
            height: {
                default: null,
                parseHTML: (element) => {
                    const rawHeight = element.getAttribute('data-height');
                    const height = rawHeight ? Number(rawHeight) : undefined;

                    return Number.isFinite(height) ? height : null;
                },
                renderHTML: (attributes) => ({
                    ...(attributes.height ? { 'data-height': attributes.height } : {}),
                }),
            },
        };
    },

    parseHTML() {
        return [{ tag: 'div[data-report-component-embed]' }];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'div',
            mergeAttributes(HTMLAttributes, {
                'data-report-component-embed': 'true',
                class: 'memo-report-component-embed-static',
            }),
            'Embedded Report Component',
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer(ReactReportComponentEmbed);
    },

    addCommands() {
        return {
            setReportComponentEmbed:
                (reportComponentId: string) =>
                ({ chain }: CommandProps) => {
                    return chain()
                        .insertContent({
                            type: this.name,
                            attrs: { reportComponentId },
                        })
                        .run();
                },
        };
    },
});
